import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  withMobileDialog,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Button,
  Paper,
} from '@material-ui/core';

import { getTenantFromUrl } from '../../../utils/urlHelper';
import PingumLogo from '../../widgets/PingumLogo';

import UserProfileCard from '../../pages/MyAccount/UserProfileCard';
import EventTypesCard from '../../pages/NotificationSettings/EventTypesCard';
import UserSubscriptions from '../../pages/UserSubscriptions';

import styles from './styles';

export const getSteps = () => [
  'Profile',
  'Notification Subscriptions',
  'Notifications Preferences',
  'Resources',
];

export const getStepContent = (step, tenantName, handleShowTutorial, classes) => {
  switch (step) {
    case 0:
      return (
        <div className={classes.stepContent}>
          <UserProfileCard />
        </div>
      );
    case 1:
      return (
        <div className={classes.stepContent}>
          <Typography variant="h3">Select workflows or dashboards to receive notifications from</Typography>
          <Typography variant="caption" gutterBottom>(These can be changed later)</Typography>
          <UserSubscriptions hidePageContent />
        </div>
      );
    case 2:
      return (
        <div className={classes.stepContent}>
          <EventTypesCard />
        </div>
      );
    case 3:
      return (
        <div className={classes.stepContent}>
          <Typography variant="h3" gutterBottom>Get the most out of Pingum</Typography>

          <br />
          <Typography variant="subtitle1">Download the mobile app</Typography>
          <Typography variant="caption" gutterBottom>Get notified and get access to your Pingum workflows on the go.</Typography>
          <div><a href="https://pingum.io/download-apps" target="blank">Get it now</a></div>
          <br />
          <Typography variant="subtitle1">Learn about pingum</Typography>
          <Typography variant="caption" gutterBottom>Read our blogs to better understand how your Pingum organization is setup and how to get the most out of it.</Typography>
          <div><a href="https://pingum.io/blog/how-to-get-started-with-pingum-in-5-minutes/" target="blank">How to Get Started with Pingum in 5 Minutes</a></div>
          <div><a href="https://pingum.io/blog/get-the-most-out-of-pingum/" target="blank">Get the Most Out of Pingum: Dashboards, Subscriptions, and Notifications</a></div>

        </div>
      );
    default:
      return 'Unknown step';
  }
};

export class UserOnboardingComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStep: 0,
      tenantName: getTenantFromUrl(),
    };
  }

  handleNext = () => {
    this.setState((state) => ({ activeStep: state.activeStep + 1 }));
  }

  handleBack = () => {
    this.setState((state) => ({ activeStep: state.activeStep - 1 }));
  }

  handleReset = () => {
    this.setState({ activeStep: 0 });
  }

  render() {
    const {
      classes,
      fullScreen,
    } = this.props;

    const steps = getSteps();
    const {
      activeStep,
      tenantName,
    } = this.state;

    return (
      <div>
        <div className={classes.root}>
          <div>
            <div className={classes.headlineContainer}>
              <Typography
                component="h2"
                variant="h2"
                className={classes.headline}
                color="inherit"
              >
                <div>Welcome to</div>
              </Typography>

              <div className={classes.logoContainer}>
                <PingumLogo fontSize={60} />
              </div>

              <Typography
                variant="h4"
                gutterBottom
                className={classes.subHeadline}
                color="inherit"
              >
                Follow these steps to setup your account.
              </Typography>
            </div>

            <Paper square className={classes.stepperContainer}>
              <Stepper activeStep={activeStep} alternativeLabel>
                {
                  steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>
                        {
                          !fullScreen
                            ? label
                            : ''
                        }
                      </StepLabel>
                    </Step>
                  ))
                }
              </Stepper>

              {
                fullScreen
                  && (
                    <Typography variant="h5" className={classes.activeStep}>
                      {steps[activeStep]}
                    </Typography>
                  )
              }

              <div className={classes.stepperActionsContainer}>
                <div className={classes.flex} />
                <Button
                  disabled={activeStep === 0}
                  onClick={this.handleBack}
                  className={classes.button}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleNext}
                  className={classes.button}
                  disabled={activeStep === steps.length}
                >
                  {activeStep === steps.length - 1
                    ? 'Finish'
                    : 'Next'}
                </Button>
                <div className={`${classes.flex} ${classes.skipContainer}`}>
                  <Button
                    href="/dashboards"
                    className={classes.button}
                  >
                    Skip
                  </Button>
                </div>
              </div>
            </Paper>
          </div>

          <div>
            {
              activeStep === steps.length
                ? (
                  <Paper square elevation={0} className={classes.resetContainer}>
                    <Typography>All steps completed -
                      you are ready to start using Pingum!
                    </Typography>
                    <Button href="/" className={classes.button} varient="contained" color="primary">
                      Take me to the home screen
                    </Button>
                  </Paper>
                )
                : (
                  <div>
                    {getStepContent(activeStep, tenantName, this.handleShowTutorial, classes)}
                  </div>
                )
            }
          </div>
        </div>
      </div>
    );
  }
}

UserOnboardingComponent.propTypes = {
  classes: PropTypes.object,
  fullScreen: PropTypes.bool,
};

UserOnboardingComponent.defaultProps = {
  classes: {},
  fullScreen: false,
};

export default withMobileDialog({ breakpoint: 'sm' })(withStyles(styles, { withTheme: true })(UserOnboardingComponent));
